import {Dates} from '../packages/dates';
import settings from '../devices/all/settings';
import { MODAL_TIMEOUT_EVENT } from '../actions/modal';
import Device from '../devices/device';
import {
  PONCONNECT,
  PONSTOP,
  PONPLAY,
  PONPAUSE,
  PONSKIP,
  PONSPEED,
  PONBUFFER
} from '../devices/all/settings';
import DeviceStorage from '../components/DeviceStorage/DeviceStorage';
import store from '../store';
import AAFPlayer from '../AAFPlayer/AAFPlayer';
import Translator from '../requests/apa/Translator';
import Asset from '../requests/apa/Asset';
import Metadata from '../requests/apa/Metadata';
import { activeMarquesina } from '../reducers/user';
import Utils from './Utils';

import { AAFPLAYER_STOP, AAFPLAYER_PLAY } from '../AAFPlayer/constants';
import FlagTimeOut from '../AAF/TimeoutAAF/FlagTimeOut';

class TimeOutAAF {
  constructor(props) {
    this.__showModal = props && props.showModal;

    this.setLastTimeEvent = this.setLastTimeEvent.bind(this);
    this.checkTimeOutEvent = this.checkTimeOutEvent.bind(this);
    this.showModalTimeOut = this.showModalTimeOut.bind(this);
    this.actionAfterClose = this.actionAfterClose.bind(this);
    this.setModalHasBeenClosed = this.setModalHasBeenClosed.bind(this);
    this.initialConfiguration = this.initialConfiguration.bind(this);
    this.resumePlay = this.resumePlay.bind(this);
    this.isActiveMarque = this.isActiveMarque.bind(this);

    this.initialConfiguration();
    this.checkTimeOutEvent();

    this.modalHasBeenClosed = false;
  }

  initialConfiguration() {
    this.isPlaying = this.isPlayingNow();
    this.seasonSave = false;
    const defaultTimeoutConfiguration =
      '{"default":{"time_wait_alert": "10000", "player":{"movie":{"after_completing_percentage_time":"20","max_time_playing":"60000"},"serie":{"num_max_episode":"3","max_time_playing":"60000"}},"any_component":{"max_inactive_time":"9000"}}}';
    this.timeOutConfiguration = Metadata.get(
      'timeout_configuration_modal',
      defaultTimeoutConfiguration
    );
    const defaultScreenSaverAvailable = '{"default":false}';
    this.screenSaverAvailable = Metadata.get(
      'screen_saver_available',
      defaultScreenSaverAvailable
    );

    const region = DeviceStorage.getItem('region');
    this.timeOutConfiguration = JSON.parse(this.timeOutConfiguration);
    this.timeOutConfiguration = this.timeOutConfiguration[region]
      ? this.timeOutConfiguration[region]
      : this.timeOutConfiguration.default;
    this.screenSaverAvailable = JSON.parse(this.screenSaverAvailable);
    this.screenSaverAvailable = this.screenSaverAvailable[region]
      ? this.screenSaverAvailable[region]
      : this.screenSaverAvailable.default;
    this.maxTimePlayer =
      this.timeOutConfiguration &&
      this.timeOutConfiguration.any_component &&
      this.timeOutConfiguration.any_component.max_inactive_time &&
      parseInt(this.timeOutConfiguration.any_component.max_inactive_time);
  }

  setLastTimeEvent() {
    const now = new Dates();
    DeviceStorage.setItem('last_time_event', now);
    FlagTimeOut.setIsFromSerie(false);
  }

  checkTimeOutEvent() {
    this.setLastTimeEvent();
    const checkInactivity =
      this.timeOutConfiguration &&
      this.timeOutConfiguration.time_wait_alert &&
      parseInt(this.timeOutConfiguration.time_wait_alert);

    this.idLastTimeEvent = setInterval(() => {
      let lastTimeEvent = DeviceStorage.getItem('last_time_event');
      lastTimeEvent = new Dates(lastTimeEvent);
      const timeToCompare = new Dates().diff(lastTimeEvent, 'milliseconds');
      const isActiveMarquesina = this.isActiveMarque();
      this.setMaxTimeplayer();
      if (timeToCompare > this.maxTimePlayer && !isActiveMarquesina) {
        this.showModalTimeOut();
        this.setModalHasBeenClosed(false);
      } else if (!isActiveMarquesina) {
        // Se pone en modo espera
        // console.log(
        //     `[TimeOutAAF] se enviará la modal en ${(this.maxTimePlayer - timeToCompare) /
        //         3.6e6}  horas o ${(this.maxTimePlayer - timeToCompare) / 60000}  minutos `
        // );
      }
    }, checkInactivity);
  }

  clear(){
    clearInterval(this.idLastTimeEvent);
  }

  setMaxTimeplayer() {
    const { isSeason } = store.getState().resume;
    this.isPlaying = this.isPlayingNow();
    let playingWell = false;
    let duration = 0;
    if (this.isPlaying) {
      duration = AAFPlayer.getDuration(); // segundos
      // console.log(`[TimeOutAAF] Duration of content ${duration}`);
      if (parseInt(duration) > 10) {
        // Mayor a 10 segundos para asegurar reproduccion.
        playingWell = true;
      }
      let player = Device.getDevice().getPlayer();
      const playerStatus = player.getCurrentPlayerState();
      if (playerStatus === PONPAUSE) {
        playingWell = false;
      }
    }
    if (playingWell) {
      duration *= 1000; // convertirlo a milisegundos
      if (isSeason && !this.seasonSave) {
        this.seasonSave = true;
        const numMaxEpisode =
          this.timeOutConfiguration &&
          this.timeOutConfiguration.player &&
          this.timeOutConfiguration.player.serie &&
          this.timeOutConfiguration.player.serie.num_max_episode &&
          parseInt(this.timeOutConfiguration.player.serie.num_max_episode);

        const maxTimePlaying =
          this.timeOutConfiguration &&
          this.timeOutConfiguration.player &&
          this.timeOutConfiguration.player.serie &&
          this.timeOutConfiguration.player.serie.max_time_playing &&
          parseInt(this.timeOutConfiguration.player.serie.max_time_playing);

        if (numMaxEpisode) {
          this.maxTimePlayer = duration * numMaxEpisode;
        } else {
          this.maxTimePlayer = maxTimePlaying;
        }
      } else if (!isSeason) {
        this.seasonSave = false;
        const percentageTimeMovie =
          this.timeOutConfiguration &&
          this.timeOutConfiguration.player &&
          this.timeOutConfiguration.player.movie &&
          this.timeOutConfiguration.player.movie.after_completing_percentage_time &&
          parseInt(
            this.timeOutConfiguration.player.movie.after_completing_percentage_time
          );

        const maxTimePlaying =
          this.timeOutConfiguration &&
          this.timeOutConfiguration.player &&
          this.timeOutConfiguration.player.movie &&
          this.timeOutConfiguration.player.movie.max_time_playing &&
          parseInt(this.timeOutConfiguration.player.movie.max_time_playing);

        if (percentageTimeMovie) {
          this.maxTimePlayer = duration * (1 + percentageTimeMovie / 100);
        } else {
          this.maxTimePlayer = maxTimePlaying;
        }
      }
      FlagTimeOut.setDuration(this.maxTimePlayer);
    } else {
      // No está playeando
      this.seasonSave = false;
      this.maxTimePlayer =
        this.timeOutConfiguration &&
        this.timeOutConfiguration.any_component &&
        this.timeOutConfiguration.any_component.max_inactive_time &&
        parseInt(this.timeOutConfiguration.any_component.max_inactive_time);
      if(FlagTimeOut.getIsFromSerie()){
        this.maxTimePlayer = FlagTimeOut.geDuration();
      }
    }
  }

  isPlayingNow() {
    const playerStateFull = AAFPlayer.getCurrentPlayingState(false);
    const playerStatePip = AAFPlayer.getCurrentPlayingState(true);
    let fullPlaying = false;
    let pipPlaying = false;

    if (playerStateFull === AAFPLAYER_PLAY) {
      const playerOptionsFull = AAFPlayer.getCurrentPlayerOptions(false);
      if (playerOptionsFull && !playerOptionsFull.source.hasOwnProperty('audiosource')) {
        fullPlaying = true;
      }
    }

    if (playerStatePip === AAFPLAYER_PLAY) {
      const playerOptionsPip = AAFPlayer.getCurrentPlayerOptions(true);
      if (playerOptionsPip && !playerOptionsPip.source.hasOwnProperty('audiosource')) {
        pipPlaying = true;
      }
    }

    return pipPlaying || fullPlaying;
  }

  isActiveMarque() {
    const activeMarque = store.getState().user && store.getState().user.activeMarquee;
    return activeMarque;
  }

  actionAfterClose() {
    // hibernar la STB
    if (!this.modalHasBeenClosed) {
      if (this.screenSaverAvailable) {
        store.dispatch(activeMarquesina(true));
      } else {
        if(Device.getDevice().getPlatform() === 'arris'){
          Utils.closeArrisSession();
        }
      }
    }
  }

  setModalHasBeenClosed(value) {
    this.modalHasBeenClosed = value;
  }

  resumePlay() {
    this.isPlaying = this.isPlayingNow();
    if (this.isPlaying) {
      AAFPlayer.resume();
    }
  }

  handleKeyPress() {
    this.setLastTimeEvent();
    if (this.isActiveMarque()) {
      this.setModalHasBeenClosed(true);
      store.dispatch(activeMarquesina(false));
      this.resumePlay();
    }
  }

  showModalTimeOut() {
    let showResume = false;
    let cb = () => {};
    const callback = () => {
      this.setLastTimeEvent();
      this.setModalHasBeenClosed(true);
      if (this.isActiveMarque()) {
        store.dispatch(activeMarquesina(false));
      }
      this.resumePlay();
    };

    let contentModal = Translator.get(
      'modal_generic_timeout_description',
      'Se ha detectado inactividad, ¿Estas ahí?'
    );
    const asset = Asset.get('ic_info_alert', '');
    let title = Translator.get('modal_generic_timeout_title', 'Alerta!');
    const timeToclose = Metadata.get('time_to_close', 60000); // un minuto

    let buttons = [
      {
        content: Translator.get('btn_modal_player_timeout_continue', 'Continuar viendo'),
        props: {
          onClick: e => {
            callback();
          }
        }
      }
    ];

    let closeTime = {
      time: timeToclose,
      cb: this.actionAfterClose
    }

    if (this.isPlaying) {
      if( Device.getDevice().getPlatform() !== 'arris'){
        buttons = [];
        showResume = true;
        closeTime = null
        cb = () => {
          this.handleKeyPress()
        }
      }
      contentModal = Translator.get(
        'modal_player_timeout_description',
        'Video Pausado, ¿Desea continuar con la reproducción?'
      );
      title = Translator.get('modal_player_timeout_title', 'Alerta!');
      AAFPlayer.pause();
    }
    // para no mostrar modal si no esta playing
    else if( Device.getDevice().getPlatform() !== 'arris'){
      return;
    }

    const modal = {
      modalType: MODAL_TIMEOUT_EVENT,
      modalProps: {
        showResume,
        content: contentModal,
        asset,
        title,
        buttons,
        closeTime,
        callbackWhenBack: cb,
      }
    };

    this.__showModal(modal);
  }
}

export default TimeOutAAF;



// WEBPACK FOOTER //
// ./src/utils/TimeOutAAF.js